import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import {AsideUserMenu} from '../../../partials'
import {useThemeMode} from '../.././../partials/layout/theme-mode/ThemeModeProvider'

const AsideDefault = () => {
  const {classes} = useLayout()
  const {mode} = useThemeMode()
  const logoSrc =
    mode === 'dark'
      ? toAbsoluteUrl('/media/logos/logo-main.png')
      : toAbsoluteUrl('/media/logos/logo-color-text.png')
  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_toggle'
      style={{
        borderRight: '1px solid var(--divider)',
        display: 'flex',
        flexDirection: 'column',
        paddingTop: '24px',
        paddingBottom: '12px',
        minHeight: 0,
        maxHeight: '100dvh',
        overflow: 'hidden',
      }}
    >
      {/* Logo */}
      <div style={{padding: '0 20px 28px 20px'}} id='kt_aside_logo'>
        <Link to='/setup' style={{display: 'block'}}>
          <img
            alt='BottomUP'
            src={logoSrc}
            style={{height: '32px', width: 'auto', objectFit: 'contain'}}
          />
        </Link>
      </div>

      {/* Nav label */}
      <div style={{padding: '0 20px 8px 20px'}}>
        <span
          style={{
            color: 'var(--text-faint)',
            fontSize: '10px',
            fontWeight: 700,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
          }}
        >
          Navigation
        </span>
      </div>

      {/* Menu */}
      <div
        id='kt_aside_menu'
        className='aside-menu flex-column-fluid'
        style={{padding: '0 12px', flex: '1 1 auto', minHeight: 0, overflow: 'hidden'}}
      >
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>

      {/* User footer */}
      <div
        id='kt_aside_footer'
        style={{
          padding: '10px 16px 0 16px',
          borderTop: '1px solid var(--divider)',
          flexShrink: 0,
        }}
      >
        <AsideUserMenu />
      </div>
    </div>
  )
}

export {AsideDefault}
